import baseLine from './src/base-line.vue';

/**
 * 基础线形图组件
 */
export const BaseLine = Object.assign(baseLine, {
  install(app) {
    app.component(baseLine.name, baseLine);
  },
});
